import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { getTeamUsersList } from '../../actions/teams';
import { CLEAR_TEAM_USERS_DROPDOWN_LIST_DATA } from '../../types/teams';
import { useFormContext } from 'react-hook-form';

export default function Users({ name, label, onChange = () => { }, org_id, isMulti = false, className, org_check_required = true, filter, isDisabled = false, is_possible_remote_support = false, required = false, prefill = [] }) {
    const dispatch = useDispatch();
    const teamUsersList = useSelector((state) => state.teams.teamUsersList);
    const isUsersDropDownLoading = useSelector((state) => state.loading.isUsersDropDownLoading);
    const methods = useFormContext();


    const memoizedUsersList = useMemo(() => {
        let usersOptions = teamUsersList || [];
        if (filter) {
            usersOptions = usersOptions.filter((user) => !filter.includes(user.value));
        }
        return usersOptions;
    }, [teamUsersList, filter]);

    const getUsers = ({ limit = 100, page = 1, query = '', org_id, is_possible_remote_support }) => {
        dispatch(getTeamUsersList({ limit, page, org_id, query, is_possible_remote_support }));
    };

    const debouncedTeamsSearchSearch = useCallback(debounce(getUsers), []);

    useEffect(() => {
        if ((org_check_required && org_id) || !org_check_required) {
            let payload = {
                limit: 100,
                page: 1,
            }
            if (org_check_required) payload.org_id = org_id;
            if (is_possible_remote_support) payload.is_possible_remote_support = is_possible_remote_support;
            getUsers(payload);
        }
    }, [org_id]);

    useEffect(() => {
        if (prefill && prefill.length > 0 && memoizedUsersList && memoizedUsersList.length > 0) {
            const find = memoizedUsersList.filter((option) => prefill.includes(option.value));
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, memoizedUsersList]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_TEAM_USERS_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            options={memoizedUsersList}
            isLoading={isUsersDropDownLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    let p = { query: event };
                    if (org_check_required && org_id) p.org_id = org_id;
                    if (is_possible_remote_support) p.is_possible_remote_support = is_possible_remote_support;
                    debouncedTeamsSearchSearch(p)
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
            isMulti={isMulti}
            readOnly={isDisabled}
            required={required}
        />
    )
}